import { configureStore } from '@reduxjs/toolkit'
import currentUserSlice from './slices/currentUserSlice'
import authSlice from './slices/authSlice'
import notificationListSlice from './slices/notificationSlice'
import wsSlice from './slices/wsSlice'
import slotListSlice from './slices/slotListSlice'
import cargoListSlice from './slices/cargoListSlice'
import transportListSlice from './slices/transportListSlice'
import gMapSlice from './slices/gMapSlice'
import settingsSlice from './slices/settingsSlice'
import commonModalSlice from './slices/commonModalSlice'
import chatSlice from './slices/chatSlice'
import saleItemListSlice from './slices/saleItemListSlice'
import currentClusterSlice from './slices/currentClusterSlice'
import orderListSlice from './slices/orderListSlice'
import complexOrderListSlice from './slices/complexOrderListSlice'
import paymentSlice from './slices/paymentSlice'
import clusterListSlice from './slices/clusterListSlice'
import executorSlice from './slices/executorSlice' // ❌ добавили
import taskSlice from './slices/taskSlice'

export const store = configureStore({
  reducer: {
    currentUser: currentUserSlice,
    currentCluster: currentClusterSlice,
    auth: authSlice,
    ws: wsSlice,
    notificationList: notificationListSlice,
    slotList: slotListSlice,
    orderList: orderListSlice,
    complexOrderList: complexOrderListSlice,
    saleItemList: saleItemListSlice,
    cargoList: cargoListSlice,
    transportList: transportListSlice,
    settings: settingsSlice,
    gMap: gMapSlice,
    commonModal: commonModalSlice,
    chat: chatSlice,
    payment: paymentSlice,
    clusterList: clusterListSlice,
    executor: executorSlice,
    task: taskSlice,
  },
})

export type RootState = ReturnType<typeof store.getState>
